export interface BasePropertyList {
    id: string;
    title: string;
    subTitle: string;
    image: string;
}

export interface ApiProperty {
    id: string;
    name: string;
    location: string;
    imageUrl: string;
    status: ApiPropertyStatus;
}

export enum ApiPropertyStatus {
    Publishing,
    Active,
    Importable,
    ImportableFromUrl,
    Draft,
}
